import axios from "axios";
import { Alert } from "rsuite";
import isEmpty from "../validations/isEmpty";
import {getError} from '../helpers/getUnauth'

import {
	GET_ACTIVITIES,
	ACTIVITY_LOADING,
	DELETE_ACTIVITY,
    CLEAR_ERRORS,
	GET_ERRORS
} from "./types";

import {getPages} from '../helpers/getPages';

// Get all contacts
export const getActivities = (pages) => async dispatch => {
    dispatch(setLoading());
    let page = getPages(pages);
	await axios
		.get("/api/v1/activities",{ params:page})
		.then(res =>{
			dispatch({
				type: GET_ACTIVITIES,
                payload: res.data.data,
                page:res.data.page
			})
		}
		)
		.catch(err =>{
            getError(err)
            dispatch({
				type: GET_ACTIVITIES,
				payload: []
			})
        }
			
		);
};

// Delete Activity
export const deleteActivity = id => dispatch => {
	axios
		.delete(`/api/v1/activities/${id}`)
		.then(res => {
			if (res.data.success) {
				dispatch({
					type: DELETE_ACTIVITY,
					payload: id
				});
				Alert.success(res.data.message, 5000);
			} else {
				Alert.error("Something went wrong", 5000);
			}
		})
		.catch(err => {
			getError(err)
			dispatch({
				type: GET_ERRORS,
				payload: err.response.data
			});
		});
};


// User loading
export const setLoading = () => {
	return {
		type: ACTIVITY_LOADING
	};
};

// Clear errors
export const clearErrors = () => {
	return {
		type: CLEAR_ERRORS
	};
};
